import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import { Stack } from 'syf-component-library/ui/spacing';
import Body from 'syf-component-library/ui/typography/Body';
import { t } from '../../../strings/i18n';
import AutopayIcon from '../../../ui/atoms/AutopayIcon';
const AutopayEnrollmentMessageBox = ({ isEnrollmentEligible, isEnrolling, isDCHCustomerAssistancePlanEnrolled }) => {
    if (!isEnrollmentEligible) {
        return null;
    }
    const neverMissAPaymentDescription = isDCHCustomerAssistancePlanEnrolled
        ? t('autopay.neverMissAPaymentDCHDesc')
        : t('autopay.neverMissAPaymentDesc');
    return (isEnrolling && (_jsxs(MessageBox, Object.assign({ icon: _jsx(AutopayIcon, { height: "48", width: "48" }), role: "alertdialog", type: "info" }, { children: [_jsx(Body, Object.assign({ "data-cy": "never-miss-payment", weight: "bold" }, { children: t('autopay.neverMissAPayment') })), _jsx(Stack, {}), _jsx(Body, Object.assign({ "data-cy": "never-miss-payment-desc" }, { children: neverMissAPaymentDescription }))] }))));
};
export default AutopayEnrollmentMessageBox;
